<template>
  <span class="k-popover-wrapper">
    <span class="k-popover-target"
      @mouseenter="showPopover"
      @mouseleave="hidePopover">
      <slot></slot>
    </span>
    <transition :name="'k-popover-'+direction">
      <span
        v-show="show"
        class="k-popover"
        :class="['k-popover--'+direction]">
        <span class="k-popover__content">
          <slot name="popover">{{ text }}</slot>
        </span>
      </span>
    </transition>
  </span>
</template>

<script>
export default {
  name: 'k-popover',

  props: {
    direction: {
      type: String,
      default: 'up',
    },
    text: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      show: false,
    };
  },

  methods: {
    showPopover() {
      this.show = true;
    },

    hidePopover() {
      this.show = false;
    },
  },

};
</script>

<style lang="scss">

  :root {
    --popover-width: 200px;
  }

  .k-popover-wrapper {
    position: relative;
  }

  .k-popover {
    position: absolute;
    z-index: var(--z-popover);
    width: 1px;
    height: 1px;

    &__content {
      position: absolute;
      padding: 10px;
      font-size: 13px;
      font-weight: 300;
      line-height: 1.3;
      color: var(--gray-almostBlack);
      text-align: center;
      text-transform: none;
      letter-spacing: 0;
      background: var(--honey-300);
      border-radius: 5px;
      white-space: initial;

      &::after {
        position: absolute;
        width: 0;
        height: 0;
        pointer-events: none;
        content: " ";
        border: solid transparent;
        border-width: 6px;
      }
    }

    &--up {
      top: 0;
      left: 50%;

      .k-popover__content {
        bottom: 10px;
        left: calc(-1 * var(--popover-width) / 2);
        width: var(--popover-width);

        &::after {
          top: 100%;
          left: 50%;
          margin-left: -6px;
          border-top-color: var(--honey-300);
        }
      }
    }

    &--down {
      bottom: 0;
      left: 50%;

      .k-popover__content {
        top: 10px;
        left: calc(-1 * var(--popover-width) / 2);
        width: var(--popover-width);

        &::after {
          bottom: 100%;
          left: 50%;
          margin-left: -6px;
          border-bottom-color: var(--honey-300);
        }
      }
    }

    &--left {
      top: 50%;
      left: 0;

      .k-popover__content {
        top: 50%;
        right: 10px;
        width: var(--popover-width);
        margin-top: -13px;
        text-align: left;

        &::after {
          top: 50%;
          left: 100%;
          margin-top: -6px;
          border-left-color: none;
        }
      }
    }

    &--right {
      top: 50%;
      right: 0;

      .k-popover__content {
        top: 50%;
        left: 10px;
        width: var(--popover-width);
        margin-top: -13px;
        text-align: right;

        &::after {
          top: 50%;
          right: 100%;
          margin-top: -6px;
          border-right-color: none;
        }
      }
    }
  }

  .k-popover-up-enter-active,
  .k-popover-up-leave-active,
  .k-popover-down-enter-active,
  .k-popover-down-leave-active,
  .k-popover-left-enter-active,
  .k-popover-left-leave-active,
  .k-popover-right-enter-active,
  .k-popover-right-leave-active {
    transition: transform 0.4s, opacity 0.3s;
    transition-delay: 0.3s;
  }

  .k-popover-up-enter-to,
  .k-popover-up-leave-from,
  .k-popover-down-enter-to,
  .k-popover-down-leave-from {
    opacity: 1;
    transform: translateY(0);
  }

  .k-popover-up-enter-from,
  .k-popover-up-leave-to {
    opacity: 0;
    transform: translateY(-10px);
  }

  .k-popover-down-enter-from,
  .k-popover-down-leave-to {
    opacity: 0;
    transform: translateY(10px);
  }

  .k-popover-left-enter-to,
  .k-popover-left-leave-from,
  .k-popover-right-enter-to,
  .k-popover-right-leave-from {
    opacity: 1;
    transform: translateX(0);
  }

  .k-popover-left-enter-from,
  .k-popover-left-leave-to {
    opacity: 0;
    transform: translateX(-10px);
  }

  .k-popover-right-enter-from,
  .k-popover-right-leave-to {
    opacity: 0;
    transform: translateX(10px);
  }

</style>
